import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <circle cx={9} cy={9} r={9} />
    <path
      d="M2.232 14.92c.264.301.547.584.848.848L15.768 3.08a9.172 9.172 0 0 0-.848-.848L2.232 14.92z"
      fill="#fff"
    />
  </svg>
);

export default SvgComponent;
